module.exports = "data:text/x-markdown;base64,CkluIHRoaXMgc2ltcGxlIGBBeGlzYCBleGFtcGxlIHdlIGNyZWF0ZSBhIG5ldyBheGlzIGZyb20gYSBgbWluYCBhbmQgYG1heGAgdmFsdWUuCgpgYGBqcwogICAgPEF4aXMgcG9zaXRpb249ImxlZnQiIG1heD0iMTAwIiBtaW49IjAiIHdpZHRoPSI4MCIgaGVpZ2h0PSIzMDAiIC8+CmBgYAoKIyMgU3R5bGluZwoKVGhlIGF4aXMgY2FuIGFsc28gYmUgc3R5bGVkLgoK"


//////////////////
// WEBPACK FOOTER
// ./src/website/examples/basic/basic_docs.md
// module id = 434
// module chunks = 0